import React from "react"
import {
  // TopTenBlogs,
  OurTeam,
  HeroSection,
  BlogInstructions,
} from "../components"

const Home = () => {
  return (
    <>
      <HeroSection />
      {/* <TopTenBlogs /> */}
      <OurTeam />
      <BlogInstructions />
    </>
  )
}

export default Home
